import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateGAs } from '@/modules/GeneralAgent/gql/general-agent.gql'
import { GeneralAgent } from '@/modules/GeneralAgent/interfaces/general-agent'
import { showErrors } from '@/utils/snack'

@Component
export default class SearchGeneralAgent extends Vue {
  candidatesGeneralAgent: GeneralAgent[] = []

  get candidatesGeneralAgentOptions () {
    return this.candidatesGeneralAgent.map(item => {
      return {
        id: +item.id,
        name: item.name
      }
    })
  }

  async mounted () {
    this.getCandidateGeneralAgents()
  }

  async getCandidateGeneralAgents (val?: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateGAs,
        variables: {
          filter: {
            name: val || ''
          },
          paging: null
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesGeneralAgent = this.$R.sortBy(this.$R.compose(this.$R.toLower, this.$R.prop('name')))(result.data.getGeneralAgents.generalAgents)
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
